/* eslint-disable */
export default {
    loginError: '',
    countries: [],
    codeError: '',
}